const DEV = {
  // SERVICE_URL: "http://uat.nfcbankonline.com:8000/apigateway",//UAT
  // SERVICE_URL: "http://195.24.192.178:8084/apigateway",
   SERVICE_URL: "https://www.nfcbankonline.com/apigateway",//Prod
  ENCRYPT_KEY: "20E38214tC181205",
  GOOGLE_MAP_API_KEY: "AIzaSyAu8_VDjnMGhi1MyPpGguTCLGiJw2mQYfg",
  LANGUAGE_LIST: ["en", "fr"],
  FORMAT_LIST: [
    { title: "Pdf", value: "PDF" },
    { title: "Excel", value: "EXCEL" },
    { title: "CSV", value: "CSV" },
  ],
  LANGUAGE_SELECTION: true,
  AUTH_LAYOUT_TYPE: "STATIC", // SLIDE
  TD_PAYMENT_METHOD: ["R", "M", "Q"],
  ACC_NO_LENGTH: 16,
  COORDINATES: { lat: 3.7878770016343934, lng: 11.547987994026181 },
  TC_MODULE_TYPE: "CUSTOM", //GENERAL
  MIN_TRANSFER_LIMIT: 1,
  CHEQUE_NO_LENGTH: "^[0-9]{5,10}$",
  BENEFICIARY_TRANSFER_TABS: ["INTERNAL", "DOMESTIC", "OWN"],
  TRANSFER_TYPES: ["IAT"],
  MONTHEND: true,
  TD_CLOSE_INSTRUCTION: true,
  CARD_REQUEST_TYPES: ["New", "Renewal", "Replacement"],
  APP_ANDROID_LINK:
    "https://play.google.com/store/apps/details?id=com.techurate.nfc&hl=en_IN&gl=US",
  APP_IOS_LINK:
    "https://apps.apple.com/us/app/nfc-bank-mobilebanking/id1296784939#?platform=ipad",
  LOCAL_CURRENCY_CODE: "XAF",
  SAVING_ACCOUNT_TYPES: ["S"],
  CURRENT_ACCOUNT_TYPES: ["U"],
  DEPOSIT_ACCOUNT_TYPES: ["Y"],
  LOAN_ACCOUNT_TYPES: ["CL"],
  TRANSACTION_CURRENCY: ["XAF"],
  SCHEDULED_TRANSFERS: false,
  SCHEDULED_PAYMENTS: false,
  CLIENT_NAME: "NFC",
};

const PROD = {
  // SERVICE_URL: "http://uat.nfcbankonline.com:8000/apigateway",//UAT
  SERVICE_URL: "https://www.nfcbankonline.com/apigateway",// prod
  //  SERVICE_URL: "http://14.143.217.151/apigateway",
  ENCRYPT_KEY: "20E38214tC181205",
  GOOGLE_MAP_API_KEY: "AIzaSyAu8_VDjnMGhi1MyPpGguTCLGiJw2mQYfg",
  LANGUAGE_LIST: ["en", "fr"],
  LANGUAGE_SELECTION: true,
  AUTH_LAYOUT_TYPE: "STATIC", // SLIDE
  TD_PAYMENT_METHOD: ["R", "M", "Q"],
  ACC_NO_LENGTH: 16,
  COORDINATES: { lat: 3.7878770016343934, lng: 11.547987994026181 },
  TC_MODULE_TYPE: "CUSTOM", //GENERAL
  MIN_TRANSFER_LIMIT: 1,
  CHEQUE_NO_LENGTH: "^[0-9]{5,10}$",
  BENEFICIARY_TRANSFER_TABS: ["INTERNAL", "DOMESTIC", "OWN"],
  TRANSFER_TYPES: ["IAT"],
  MONTHEND: true,
  TD_CLOSE_INSTRUCTION: true,
  CARD_REQUEST_TYPES: ["New", "Renewal", "Replacement"],
  APP_ANDROID_LINK:
    "https://play.google.com/store/apps/details?id=com.techurate.nfc&hl=en_IN&gl=US",
  APP_IOS_LINK:
    "https://apps.apple.com/us/app/nfc-bank-mobilebanking/id1296784939#?platform=ipad",
  LOCAL_CURRENCY_CODE: "XAF",
  SAVING_ACCOUNT_TYPES: ["S"],
  CURRENT_ACCOUNT_TYPES: ["U"],
  DEPOSIT_ACCOUNT_TYPES: ["Y"],
  LOAN_ACCOUNT_TYPES: ["CL"],
  TRANSACTION_CURRENCY: ["XAF"],
  SCHEDULED_TRANSFERS: false,
  SCHEDULED_PAYMENTS: false,
  CLIENT_NAME: "NFC",
};

const config = process.env.REACT_APP_STAGE === "PROD" ? PROD : DEV;

export default { ...config };
